import React from "react";
type SectionHeadingProps = {
  eyebrow: string;
  title: React.ReactNode;
  intro?: React.ReactNode;
  tone?: "light" | "dark";
  align?: "left" | "center";
  id?: string;
};
export function SectionHeading({
  eyebrow,
  title,
  intro,
  tone = "light",
  align = "left",
  id
}: SectionHeadingProps) {
  const onDark = tone === "dark";
  return <div className={align === "center" ? "mx-auto text-center" : ""} data-id="element-435" data-mp="rxhtvsvefh8b">
      <p className={`eyebrow ${onDark ? "text-gold-soft" : "text-gold-hover"}`} data-id="element-436" data-mp="mzq2czyo1x4n">{eyebrow}</p>
      <h2 id={id} className={`h2-fluid mt-4 font-serif font-normal ${onDark ? "text-white" : "text-navy"}`} data-id="element-437" data-mp="i7ogcmbp4s1f">
        {title}
      </h2>
      {intro && <p className={`measure mt-6 text-lg ${align === "center" ? "mx-auto" : ""} ${onDark ? "text-white/75" : "text-muted"}`} data-id="element-438" data-mp="d6io0ply76sf">
          {intro}
        </p>}
    </div>;
}